export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

// 金额转换3位变成,号隔开
function toThousands (num) {
  var result = ''
  var counter = 0
  var dot = String(num).indexOf('.')
  if (dot !== -1) {
    // alert("有小数点");
    // 获取小数点后面的数字(indexOf和substring都不支持数字，所以要先转字符串才可以用)
    var dotCnt = String(num).substring(dot + 1, num.length)

    // 获取小数点前面的数字
    num = String(num).split('.')[0]
    num = (num || 0).toString()
    for (var i = num.length - 1; i >= 0; i--) {
      counter++
      result = num.charAt(i) + result
      if (!(counter % 3) && i !== 0) { result = ',' + result }
    }
    result = result + '.' + dotCnt
    // console.log(result, '有小数点')
    return result
  } else {
    // alert("没有小数点");

    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.00'
  }
}

// 卡号转换4位变成,号隔开
function tofour (num) {
  var result = ''
  var counter = 0
  var dot = String(num).indexOf('.')
  if (dot !== -1) {
    // alert("有小数点");
    // 获取小数点后面的数字(indexOf和substring都不支持数字，所以要先转字符串才可以用)
    var dotCnt = String(num).substring(dot + 1, num.length)

    // 获取小数点前面的数字
    num = String(num).split('.')[0]
    num = (num || 0).toString()
    for (var i = num.length - 1; i >= 0; i--) {
      counter++
      result = num.charAt(i) + result
      if (!(counter % 4) && i !== 0) { result = ' ' + result }
    }
    result = result + '.' + dotCnt
    // console.log(result, '有小数点')
    return result
  } else {
    // alert("没有小数点");
    return (num || 0).toString().replace(/(\d)(?=(?:\d{4})+$)/g, '$1 ')
  }
}

// 两个浮点数求和
function accAdd (num1, num2) {
  var r1, r2, m
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // return (num1*m+num2*m)/m;
  return Math.round(num1 * m + num2 * m) / m
}

// 两个浮点数相减
function accSub (num1, num2) {
  var r1, r2, m, n
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2
  return (Math.round(num1 * m - num2 * m) / m).toFixed(n)
}

// 两个浮点数相除
function accDiv (num1, num2) {
  var t1, t2, r1, r2
  try {
    t1 = num1.toString().split('.')[1].length
  } catch (e) {
    t1 = 0
  }
  try {
    t2 = num2.toString().split('.')[1].length
  } catch (e) {
    t2 = 0
  }
  r1 = Number(num1.toString().replace('.', ''))
  r2 = Number(num2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}

// 两个浮点数相乘
function accMula (num1, num2) {
  var m = 0; var s1 = num1.toString(); var s2 = num2.toString()
  try { m += s1.split('.')[1].length } catch (e) { };
  try { m += s2.split('.')[1].length } catch (e) { };
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 手机号中间四位***号
function subStrPhone (tel) {
  tel = '' + tel
  return tel.substr(0, 3) + '****' + tel.substr(7)
}

// 限制输入数字 保留两位小数点
export function limitNumber (num) {
  // /修复第一个字符是小数点 的情况.
  if (num !== '' && num.substr(0, 1) === '.') {
    num = ''
  }
  num = num.replace(/^0*(0\.|[1-9])/, '$1')// 解决 粘贴不生效
  num = num.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
  num = num.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
  num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  num = num.replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入两个小数
  if (num.indexOf('.') < 0 && num !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (num.substr(0, 1) === '0' && num.length === 2) {
      num = num.substr(1, num.length)
    }
  }
  return num
}

// 获取日期20210728182800
function getTimeAsFileName (params) {
  var date = new Date()
  var seperator1 = ''
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  var strHour = date.getHours()
  var strMin = date.getMinutes()
  var strSec = date.getSeconds()

  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  if (strHour >= 1 && strHour <= 9) {
    strHour = '0' + strHour
  }
  if (strMin >= 1 && strMin <= 9) {
    strMin = '0' + strMin
  }
  if (strSec >= 1 && strSec <= 9) {
    strSec = '0' + strSec
  }

  var currentdate = year + seperator1 + month + seperator1 + strDate + seperator1 + strHour + seperator1 + strMin + seperator1 + strSec
  return currentdate
}

export default {
  formatDate,
  padLeftZero,
  toThousands,
  tofour,
  accAdd,
  limitNumber,
  accSub,
  accDiv,
  accMula,
  subStrPhone,
  getTimeAsFileName
}



// WEBPACK FOOTER //
// ./src/libs/utils/dateUtils.js